import { Question } from "@/types/question";
import { createContext } from "react";

export interface SurveyEditorContextType {
  removeQuestion: (index: number) => void;
  moveQuestion: (from: number, to: number) => void;
  addQuestion: ({
    question,
    insertAt,
  }: {
    question?: Question | Question[];
    insertAt?: number;
  }) => void;
  isQuestionRemoved: (index: number) => boolean;
  switchQuestionType: (index: number, type: string) => void;
  handleCleanSchema: () => void;
  isNewSurvey: () => boolean;
  setArchiveFlag: (archive: boolean) => void;
}

const SurveyEditorContext = createContext<SurveyEditorContextType | undefined>(
  undefined,
);

export default SurveyEditorContext;
